var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex mt-5",attrs:{"dense":"","flat":""}},[_c('v-spacer'),_c('create')],1)}
var staticRenderFns = []

export { render, staticRenderFns }